import React, { useEffect, useRef } from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
export function Hero() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Imperatively enforce attributes that mobile browsers (especially iOS) require for autoplay.
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', 'true');
    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          // Autoplay blocked — will retry on next user interaction
        });
      }
    };
    // Try immediately
    tryPlay();
    // Retry on key readiness events (mobile often needs this)
    video.addEventListener('loadedmetadata', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);
    // Final fallback: first user gesture anywhere on the page
    const onUserGesture = () => {
      tryPlay();
      window.removeEventListener('touchstart', onUserGesture);
      window.removeEventListener('click', onUserGesture);
    };
    window.addEventListener('touchstart', onUserGesture, {
      passive: true,
      once: true
    });
    window.addEventListener('click', onUserGesture, {
      once: true
    });
    return () => {
      video.removeEventListener('loadedmetadata', tryPlay);
      video.removeEventListener('loadeddata', tryPlay);
      video.removeEventListener('canplay', tryPlay);
      window.removeEventListener('touchstart', onUserGesture);
      window.removeEventListener('click', onUserGesture);
    };
  }, []);
  return <section className="relative overflow-hidden min-h-screen min-h-[100svh] flex flex-col justify-center pt-[140px] md:pt-[clamp(100px,18vw,220px)] pb-[calc(40vh+var(--s-16))] md:pb-[calc(50vh+var(--s-20))]" data-id="element-177">
      {/* Video Background */}
      <video ref={videoRef} autoPlay loop muted defaultMuted playsInline
    // @ts-ignore — legacy iOS attribute
    webkit-playsinline="true" preload="auto" disablePictureInPicture controls={false} className="absolute inset-0 w-full h-full object-cover z-0 opacity-30 pointer-events-none" data-id="element-178">
        <source src="https://cdn.magicpatterns.com/uploads/uoxqfsHKX6vyJSLPPpTsDd/6682261-uhd_3840_2160_25fps.mp4" type="video/mp4" data-id="element-179" />
      </video>

      {/* Dark overlay — riduce la luminosità del video per migliorare il contrasto del testo */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: 'linear-gradient(180deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.55) 50%, rgba(0,0,0,0.75) 100%)'
    }} aria-hidden="true" data-id="element-180" />

      {/* Radial gradient */}
      <div className="absolute top-[-120px] right-[-240px] w-[720px] h-[720px] bg-[radial-gradient(circle,var(--accent-100),transparent_60%)] pointer-events-none z-0" data-id="element-181"></div>

      <div className="wrap relative z-10" data-id="element-182">
        <div className="section-tag section-tag--accent mb-6 inline-flex items-center gap-3 px-4 py-2 border border-default bg-elev1 rounded-full motion-fade-up" data-id="element-183">
          AI DeliverY Automation
        </div>

        <h1 className="text-display-hero mb-6 color-ink-primary motion-fade-up stagger-1 md:text-[68px] text-white" data-id="element-184">
          Riduci i costi di{' '}
          <strong className="font-medium text-white" data-id="element-185">delivery</strong> e{' '}
          <strong className="font-medium text-white" data-id="element-186">aumenta il valore</strong>{' '}
          di ogni ordine.
        </h1>

        <p className="text-body-xl color-ink-primary max-w-[860px] mb-[var(--s-12)] motion-fade-up stagger-2" data-id="element-187">
          Aisac è la piattaforma AI che migliora l'esperienza di delivery,
          assicurandoti un alto tasso di consegna, senza sprechi o costo
          nascosti.
        </p>

        <div className="flex gap-4 items-center flex-wrap motion-fade-up stagger-3" data-id="element-188">
          <a href="#cta" className="btn-primary" data-id="element-189">
            Richiedi una demo
            <ArrowRight className="w-[18px] h-[18px]" data-id="element-190" />
          </a>
          <a href="#framework" className="btn-secondary" data-id="element-191">
            <PlayCircle className="w-4 h-4" data-id="element-192" />
            Come funziona
          </a>
        </div>
      </div>
    </section>;
}